import {PUB0} from '../content/economy';
import {AX,SCALE} from '../content/axes';
import {ISS} from '../content/states';
import {S} from './state';
import {clamp} from './util';
import {axes} from './axes';


export const isv=(id:string):number=>S.issues&&S.issues[id]?S.issues[id].sev:ISS[id].sev;
export function pub(a?:any){
  let v=(PUB0[a]||0)+(S.zg?.[a]||0);
  if(a==='migration')v-=(isv('asyl')-52)*.02;
  if(a==='klima')v+=(isv('klima')-48)*.015;
  if(a==='wohnen')v+=(isv('wohnen')-62)*.015;
  if(a==='innen')v+=(isv('sicher')-44)*.02;
  if(a==='sicherheit')v+=(isv('wehr')-50)*.012;
  if(a==='sozial')v+=(isv('kinderarmut')-52)*.01;
  if(a==='atom')v+=(isv('energie')-52)*.02;
  if(a==='haushalt')v-=S.saldo<-40?.5:0;
  return clamp(v,-2,2);
}
export const scaleLabel=(v:any)=>SCALE.find((s:any)=>s[0]===Math.round(clamp(v,-2,2)))[1];
export function progFit(){const A=axes();return A.reduce((s:any,a:any)=>s+1-Math.abs(S.you[a]-pub(a))/4,0)/A.length}
export const progBonus:any=()=>clamp((progFit()-.75)*10,-2,2);
